import gql from 'graphql-tag';

export const ENGAGEMENT_VOTE = gql`
  mutation engagementVote($engagementId: NexusId, $optionIds: [NexusId]) {
    engagementVote(engagementId: $engagementId, optionIds: $optionIds) {
      answerDescription
      ctaLink
      ctaText
      id
      isCurrent
      isMultiSelect
      options {
        displayOrder
        engagementId
        id
        isCorrect
        name
        totalVotes
      }
      question
      type
      resultsRequireAuth
      resultsRequireKnown
    }
  }
`;
